import http from '~/http/services/pos';
import { usePrinter } from '~/App/Layout/providers/PrinterProviderV2';
import message from '~/utils/message';
import i18n from '~/i18n';
import { useCallback } from 'react';
import { PrintResponse } from '~/types/printer';

export const usePrintOrder = () => {
  const { print } = usePrinter();
  const printOrderBatch = useCallback(
    async (orderId: string, batchIndex: number) => {
      try {
        await print(({ printMethod }) => {
          return http.post<PrintResponse>(
            `/api/v2/orders/${orderId}/batches/${batchIndex}/prints`,
            { printMethod }
          );
        });
        message.success(i18n.t('message_success_print'));
      } catch (e: any) {
        message.error(e.message);
      }
    },
    [print]
  );

  const printOrderDetailReceipt = useCallback(
    async (orderId: string) => {
      try {
        await print(({ printMethod, printerId }) => {
          return http.post<PrintResponse>(
            `/api/v2/orders/${orderId}/receipts/cashier`,
            {
              printMethod,
              printerId,
            }
          );
        });
        message.success(i18n.t('message_success_print'));
      } catch (e: any) {
        message.error(e.message);
      }
    },
    [print]
  );

  const printOrderHistoryDetailReceipt = useCallback(
    async (orderId: string) => {
      try {
        await print(({ printMethod, printerId }) => {
          return http.post<PrintResponse>(
            `/api/v2/orders/${orderId}/receipts`,
            {
              printMethod,
              printerId,
            }
          );
        });
        message.success(i18n.t('message_success_print'));
      } catch (e: any) {
        message.error(e.message);
      }
    },
    [print]
  );
  return {
    printOrderBatch,
    printOrderDetailReceipt,
    printOrderHistoryDetailReceipt,
  };
};
